/* eslint-disable import/prefer-default-export */
import { useModal } from 'vue-final-modal'
import PreviewModal from '@organisms/preview-modal/preview-modal.vue'
import emitter from '../../emitter'

export const openmodal = (el, binding) => {
  if (el.classList.contains('event-attached')) {
    return
  }

  const { open, close } = useModal({
    component: PreviewModal,
    attrs: {
      ...binding.value,
      clickToClose: true,
      escToClose: true,
    },
  })

  const handleModalClick = (event) => {
    if (isPdf(binding) && isMobile()) {
      window.open(binding.value.share.url, '_blank')
      return
    }

    event.preventDefault()
    openModal()
  }

  const openModal = () => {
    open()
  }

  const closeModal = () => {
    close()
  }
  emitter.$emit('openmodal', binding.value)
  emitter.$on('closemodal', closeModal)

  el.addEventListener('click', handleModalClick, true)

  el.classList.add('event-attached')
}

const isMobile = () => {
  return window.innerWidth <= 1240
}

const isPdf = (binding) => {
  return binding.value.type === 'pdf'
}
